import type { jsPDF } from "jspdf";
import { pdfEmbeddedFontName } from "@vida/surf-core";

let registered = false;

async function loadFontBase64(path: string): Promise<string> {
  const res = await fetch(path);
  if (!res.ok) throw new Error(`Font non trovato: ${path}`);
  const buf = await res.arrayBuffer();
  let binary = "";
  const bytes = new Uint8Array(buf);
  for (let i = 0; i < bytes.length; i += 1) {
    binary += String.fromCharCode(bytes[i]!);
  }
  return btoa(binary);
}

type FontEntry = { vfsName: string; url: string; jsPdfName: string };

const SURF_PDF_FONT_MANIFEST: FontEntry[] = [
  { vfsName: "SurfSans-400.ttf", url: "/fonts/Inter-Regular.ttf", jsPdfName: "SurfSans-400" },
  { vfsName: "SurfSans-500.ttf", url: "/fonts/Inter-Medium.ttf", jsPdfName: "SurfSans-500" },
  { vfsName: "SurfSans-600.ttf", url: "/fonts/Inter-SemiBold.ttf", jsPdfName: "SurfSans-600" },
  { vfsName: "SurfSans-700.ttf", url: "/fonts/Inter-Bold.ttf", jsPdfName: "SurfSans-700" },
  { vfsName: "SurfSans-800.ttf", url: "/fonts/Inter-ExtraBold.ttf", jsPdfName: "SurfSans-800" },
  {
    vfsName: "SurfSerif-400.ttf",
    url: "/fonts/SourceSerif4-Regular.ttf",
    jsPdfName: "SurfSerif-400",
  },
  {
    vfsName: "SurfSerif-600.ttf",
    url: "/fonts/SourceSerif4-SemiBold.ttf",
    jsPdfName: "SurfSerif-600",
  },
  { vfsName: "SurfSerif-700.ttf", url: "/fonts/SourceSerif4-Bold.ttf", jsPdfName: "SurfSerif-700" },
  {
    vfsName: "SurfMono-400.ttf",
    url: "/fonts/JetBrainsMono-Regular.ttf",
    jsPdfName: "SurfMono-400",
  },
  { vfsName: "SurfMono-700.ttf", url: "/fonts/JetBrainsMono-Bold.ttf", jsPdfName: "SurfMono-700" },
];

/** Register self-hosted Surf OFL fonts — one jsPDF face per (family, weight). */
export async function ensureSurfPdfFonts(pdf: jsPDF): Promise<void> {
  if (registered) return;
  const blobs = await Promise.all(
    SURF_PDF_FONT_MANIFEST.map(async (entry) => ({
      entry,
      data: await loadFontBase64(entry.url),
    })),
  );
  for (const { entry, data } of blobs) {
    pdf.addFileToVFS(entry.vfsName, data);
    pdf.addFont(entry.vfsName, entry.jsPdfName, "normal");
  }
  registered = true;
}

/** Exact jsPDF font name for a Surf family + weight (no built-in fallback). */
export function pdfFontForResolved(font: string, weight: number): { name: string; style: "normal" } {
  return { name: pdfEmbeddedFontName(font, weight), style: "normal" };
}
